import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layouts/Dashboard";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import useReload from "../../hooks/useReload";
import { powerBiCRUD } from "../../http";
import LoadingContainer from "../../components/Loader/LoadingContainer";
import Ses18Filter from "./Ses18Filter";

const Ses18Table1 = () => {
    const location = useLocation();
    const [query, setQuery] = useState({
        paging: { skip: 0 },
        filter: {}
    });
    const [data, setData] = useState({ rows: [] });
    const [data2, setData2] = useState({ rows: [] });
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const { push } = useHistory();

    const { reload, reloadValue } = useReload();

    const fetchAsync = async () => {
        setIsLoading(true);

        try {
            let response = await powerBiCRUD.post("table1/part1", query);
            setData(response);

            response = await powerBiCRUD.post("table1/part2", query);
            setData2(response);

            setIsLoading(false);
        } catch (err) {
            setError(err.message || "Ошибка при загрузке данных");
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchAsync();
    }, [query]);

    if (error) {
    return <div>Ошибка: {error}</div>;
    }

    if (!data) {
    return <div>Нет данных для отображения</div>;
    }

    return (
        <DashboardLayout>
            <Ses18Filter query={query} setQuery={setQuery} />
        <LoadingContainer loading={isLoading}>
            <table className="table table-bordered ses18-table">
                <thead>
                    <tr>
                        <th rowSpan={4}>Объекты водоснабжения</th>
                        <th rowSpan={4}>№ строки</th>
                        <th rowSpan={2} colSpan={2}>Число объектов, единиц</th>
                        <th rowSpan={4}>Обследовано объектов, единиц</th>
                        <th rowSpan={4}>В том числе с применением лабораторных методов, единиц</th>
                        <th rowSpan={4}>Число обсле-дований, единиц</th>
                        <th rowSpan={4}>Число объектов, не отвечающих НД, единиц</th>
                        <th rowSpan={4}>число выданных предписаний об устранении нарушений законодательства</th>
                        <th rowSpan={4}>Из них выполнено в срок</th>
                        <th colSpan={8}>Исследовано проб воды на:</th>
                    </tr>
                    <tr>
                        <th rowSpan={2} colSpan={2}>санитарно-химические показатели, единиц</th>
                        <th colSpan={4}>микробиологические показатели, единиц</th>
                        <th rowSpan={2} colSpan={2}>цисты лямблии, единиц</th>
                    </tr>
                    <tr>
                        <th rowSpan={2}>иссле-довано проб</th>
                        <th rowSpan={2}>в т.ч. не соответствуют норма-тивам</th>
                        <th colSpan={2}>индекс колифагов</th>
                    </tr>
                    <tr>
                        <th>исследовано проб </th>
                        <th>из них не соотве-тствуют норма-тивам</th>
                        <th>иссле-довано проб</th>
                        <th>в т.ч. положительных</th>
                        <th>иссле-довано проб</th>
                        <th>в т.ч. положительных</th>
                    </tr>
                    <tr>
                        <th>А</th>
                        <th>Б</th>
                        <th>1</th>
                        <th>2</th>
                        <th>3</th>
                        <th>4</th>
                        <th>5</th>
                        <th>6</th>
                        <th>7</th>
                        <th>8</th>
                        <th>9</th>
                        <th>10</th>
                        <th>11</th>
                        <th>12</th>
                        <th>13</th>
                        <th>14</th>
                        <th>15</th>
                        <th>16</th>
                    </tr>
                </thead>
                <tbody>
                    {data.rows.map((row, index) => (
                        <tr key={index}>
                            {row.map((cell, cellIndex) => (
                                <td key={cellIndex}>{cell}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
            <div>продолжение таблицы 1</div>
            <table className="table table-bordered ses18-table">
                <thead>
                    <tr>
                        <th rowSpan={4}>Объекты водоснабжения</th>
                        <th rowSpan={4}>№ строки</th>
                        <th colSpan="8">Исследовано проб воды в ходе санитарно-эпидемиологического мониторинга</th>                        
                        <th colSpan="2">Передано материалов в суд</th>
                        <th rowSpan={4}>число наложенных штрафов</th>
                        <th rowSpan={4}>из них взыскано</th>
                        <th rowSpan={4}>число лиц, отстранённых от работы</th>
                    </tr>
                    <tr>
                        <th colSpan="2" rowSpan={2}>Санитарно-химические показатели, единиц</th>
                        <th colSpan="4">Микробиологические показатели, единиц</th>
                        <th colSpan="2" rowSpan={2}>Цисты лямблии, единиц</th>                        
                        <th rowSpan={3}>всего</th>
                        <th rowSpan={3}>принято решений в пользу службы</th>                        
                    </tr>
                    <tr>
                        <th rowSpan={2}>исследовано проб</th>
                        <th rowSpan={2}>в т.ч. не соответствуют нормам</th>
                        <th colSpan="2">Индекс коли-фагов</th>                        
                    </tr>
                    <tr>                        
                        <th>исследовано проб</th>
                        <th>в т.ч. не соответствуют нормам</th>
                        <th>исследовано проб</th>
                        <th>в т.ч. поло-житель-ных</th>
                        <th>исследовано проб</th>
                        <th>в т.ч. поло-житель-ных</th>                        
                    </tr>
                    <tr>
                        <th>А</th>
                        <th>Б</th>
                        <th>17</th>
                        <th>18</th>
                        <th>19</th>
                        <th>20</th>
                        <th>21</th>
                        <th>22</th>
                        <th>23</th>
                        <th>24</th>
                        <th>25</th>
                        <th>26</th>
                        <th>27</th>
                        <th>28</th>
                        <th>29</th>
                    </tr>
                </thead>
                <tbody>
                    {data2.rows.map((row, index) => (
                        <tr key={index}>
                            {row.map((cell, cellIndex) => (
                            <td key={cellIndex}>{cell}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </LoadingContainer>
        </DashboardLayout>
    )
};

export default Ses18Table1;
